export default class Video {
    constructor(element) {
        this.element = element
        this.overlay = this.element.querySelector(".video-controls");
        this.video = this.element.querySelector("video");
        this.iframe = this.element.querySelector('iframe');

        if (this.video) this.element.addEventListener('click', () => this.toggle());
        if (this.video) this.video.addEventListener('ended', () => this.stopVideo());
    }

    toggle() {
        console.log("Test")
        if (this.video.paused) {
            this.startVideo();
        } else {
            this.stopVideo();
        }
    }

    startVideo() {
        this.video.play();
        this.element.classList.add("playing");
    }

    stopVideo() {
        this.video.pause();
        this.element.classList.remove("playing");
    }
}
